module.exports = __webpack_public_path__ + "4bd8c82259da6e93f9db3fb702afdcff.fbx";